import React, { Fragment, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import icon from '../../images/icon/magic.svg';
import gImg1 from '../../images/logo-fff.png';
import Seo from '../../components/Seo';

const AboutPage = (props) => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();

    // Set language based on URL parameter
    useEffect(() => {
        if (lang && (lang === 'en' || lang === 'ka')) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    return (
        <Fragment>
            <Seo 
                title={t('seo.about.title')}
                description={t('seo.about.description')}
                keywords={t('seo.about.keywords')}
                url={`/${lang}/about`}
            />
            <Layout>
                
                {/* Hero Section with Animation */}
                <motion.section
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="page-title pt-150 pos-rel bg_img"
                >
                    <div className="container">
                        <div className="page-title-wrap sd-title-wrap">
                            <div className="row mt-none-30 align-items-end">
                                <div className="col-lg-9 mt-30">
                                    <motion.div 
                                        initial={{ opacity: 0, x: -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ delay: 0.3 }}
                                        className="page-title-box"
                                    >
                                        <motion.span 
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 0.5 }}
                                            className="sub-title"
                                        >
                                            <img src={icon} alt="" /> {t('about.title')}
                                        </motion.span>
                                        <motion.h2 
                                            initial={{ opacity: 0, y: 30 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ delay: 0.7 }}
                                            className="title"
                                        >
                                            {t('about.subtitle')}
                                        </motion.h2>
                                    </motion.div>
                                </div>
                                <div className="col-lg-3 mt-30 justify-content-center d-flex">
                                    <motion.div 
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: 0.9, duration: 0.5 }}
                                        className="sd-right-img pos-rel"
                                    >
                                        <img src={gImg1} alt="" />
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>

                {/* Content Section with Animation */}
                <motion.section 
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5, duration: 0.8 }}
                    className="terms&conditions-section pt-85 pb-85 cp-det-bg"
                >
                    <div className="container">
                        <div className="terms-section_inner">
                            <div className="row">
                                <div className="col-lg-12">
                                    <motion.div 
                                        initial={{ opacity: 0, y: 30 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: 0.7, duration: 0.6 }}
                                        className="item-details-widget" 
                                        style={{ padding: '50px 50px 60px 50px' }}
                                    >
                                        <motion.h3 
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 0.9 }}
                                            className="mb-20"
                                        >
                                            🌍 {t('about.aboutOrbitronix')}
                                        </motion.h3>
                                        <motion.p 
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 1.0 }}
                                        >
                                            {t('about.content')}
                                        </motion.p>
                                        <motion.p 
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 1.1 }}
                                        >
                                            {t('about.teamDescription')}
                                        </motion.p>
                                        <motion.p 
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 1.2 }}
                                        >
                                            {t('about.transparency')}
                                        </motion.p>
                                        <motion.p 
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 1.3 }}
                                        >
                                            {t('about.partnership')}
                                        </motion.p>
                                        <motion.p 
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 1.4 }}
                                        >
                                            {t('about.conclusion')}
                                        </motion.p>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>

                {/* <WorkFlow /> */}
            </Layout>
        </Fragment>
    );
};

export default AboutPage;